import { render } from "./Xiaoshou.vue?vue&type=template&id=8461a9c8"
import script from "./Xiaoshou.vue?vue&type=script&lang=js"
export * from "./Xiaoshou.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__